module.exports = __webpack_public_path__ + "static/DazzlePanel-630449412f733b048e26db88aeaf95d2.png";